var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "footer" },
    [
      _c(
        "md-toolbar",
        { staticClass: "footer", attrs: { "elevation-1": "" } },
        [
          _c(
            "div",
            { staticClass: "md-layout md-gutter md-alignment-center" },
            [
              _c(
                "div",
                { staticClass: "md-layout-item md-size-30 md-medium-hide" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout md-gutter md-alignment-center-left"
                    },
                    [
                      _c(
                        "h4",
                        {
                          staticStyle: {
                            "padding-right": "20px",
                            "padding-left": "20px"
                          }
                        },
                        [
                          _vm._v(
                            "\n            © 2017-" +
                              _vm._s(new Date().getFullYear()) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://kompetenzzentrum-kaiserslautern.digital"
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: require("../../../assets/logo.png") }
                          })
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "md-layout-item md-size-10 md-medium-size-45 md-small-size-50 md-xsmall-size-100"
                },
                [
                  _c("router-link", { attrs: { to: "/impressum" } }, [
                    _c("strong", [_vm._v("Impressum")])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "md-layout-item md-size-10 md-medium-size-45 md-small-size-50 md-xsmall-size-100"
                },
                [
                  _c("router-link", { attrs: { to: "/confidentiality" } }, [
                    _c("strong", [_vm._v("Datenschutzerklärung")])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "md-layout-item md-size-20 md-medium-hide"
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "md-layout-item md-size-20 md-medium-hide" },
                [
                  _c("div", { staticClass: "md-layout-item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "http://www.bmwi.de/Navigation/DE/Home/home.html"
                        }
                      },
                      [
                        _c("img", {
                          staticStyle: { "padding-right": "20px" },
                          attrs: {
                            src: require("../../../assets/BMWi_Fz_2017_Office_Farbe_de.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      { attrs: { href: "https://www.mittelstand-digital.de" } },
                      [
                        _c("img", {
                          attrs: { src: require("../../../assets/md.jpg") }
                        })
                      ]
                    )
                  ])
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          attrs: { "md-active": _vm.newsletter },
          on: {
            "update:mdActive": function($event) {
              _vm.newsletter = $event
            },
            "update:md-active": function($event) {
              _vm.newsletter = $event
            }
          }
        },
        [
          _c(
            "form",
            {
              attrs: { novalidate: "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.validateData.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "md-card",
                [
                  _c("md-card-header", [
                    _c("div", { staticClass: "md-title" }, [
                      _vm._v("Newsletteranmeldung")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("md-card-content", [
                    _c("div", { staticClass: "md-layout md-gutter" }, [
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-small-size-100" },
                        [
                          _c(
                            "md-field",
                            { class: _vm.getValidationClass("firstname") },
                            [
                              _c("label", { attrs: { for: "first-name" } }, [
                                _vm._v("Vorname")
                              ]),
                              _vm._v(" "),
                              _c("md-input", {
                                attrs: {
                                  name: "first-name",
                                  id: "first-name",
                                  autocomplete: "given-name",
                                  disabled: _vm.sending
                                },
                                model: {
                                  value: _vm.form.firstname,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "firstname", $$v)
                                  },
                                  expression: "form.firstname"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.$v.form.firstname.required
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Der Vorname ist notwendig")
                                  ])
                                : !_vm.$v.form.firstname.minlength
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Ungültiger Vorname")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-small-size-100" },
                        [
                          _c(
                            "md-field",
                            { class: _vm.getValidationClass("lastname") },
                            [
                              _c("label", { attrs: { for: "last-name" } }, [
                                _vm._v("Nachname")
                              ]),
                              _vm._v(" "),
                              _c("md-input", {
                                attrs: {
                                  name: "last-name",
                                  id: "last-name",
                                  autocomplete: "family-name",
                                  disabled: _vm.sending
                                },
                                model: {
                                  value: _vm.form.lastname,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "lastname", $$v)
                                  },
                                  expression: "form.lastname"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.$v.form.lastname.required
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Der Nachname ist notwendig")
                                  ])
                                : !_vm.$v.form.lastname.minlength
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Ungültiger Nachname")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "md-layout md-gutter" }, [
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-small-size-100" },
                        [
                          _c(
                            "md-field",
                            { class: _vm.getValidationClass("gender") },
                            [
                              _c("label", { attrs: { for: "gender" } }, [
                                _vm._v("Geschlecht")
                              ]),
                              _vm._v(" "),
                              _c(
                                "md-select",
                                {
                                  attrs: {
                                    name: "gender",
                                    "md-dense": "",
                                    disabled: _vm.sending
                                  },
                                  model: {
                                    value: _vm.form.gender,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "gender", $$v)
                                    },
                                    expression: "form.gender"
                                  }
                                },
                                [
                                  _c("md-option", { attrs: { value: "m" } }, [
                                    _vm._v("männlich")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-option", { attrs: { value: "f" } }, [
                                    _vm._v("weiblich")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-option", { attrs: { value: "d" } }, [
                                    _vm._v("divers")
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-error" }, [
                                _vm._v("Das Geschlecht ist notwendig")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "md-layout-item md-small-size-100"
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "md-layout md-gutter" }, [
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-size-100" },
                        [
                          _c(
                            "md-field",
                            { class: _vm.getValidationClass("email") },
                            [
                              _c("label", { attrs: { for: "email" } }, [
                                _vm._v("Email")
                              ]),
                              _vm._v(" "),
                              _c("md-input", {
                                attrs: {
                                  type: "email",
                                  name: "email",
                                  id: "email",
                                  autocomplete: "email",
                                  disabled: _vm.sending
                                },
                                model: {
                                  value: _vm.form.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "email", $$v)
                                  },
                                  expression: "form.email"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.$v.form.email.required
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Die Mail-Adresse wird benötigt")
                                  ])
                                : !_vm.$v.form.email.email
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Ungültige Mail-Adresse")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    this.error
                      ? _c("span", { staticClass: "md-error" }, [
                          _vm._v(
                            "Der gewählte Benutzername ist bereits vergeben. Bitte verwenden\n            Sie eine andere Email-Adresse."
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-card-actions",
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "md-primary",
                          attrs: { type: "submit" }
                        },
                        [_vm._v("Anmelden")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c808510", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c808510","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/footer/WernerFooter.vue
// module id = null
// module chunks = 